import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import { openProductDetailModal } from '../../../../../../store/products/products.actions';
import { useProductCatalogFeatureGate } from '../../../../../../feature-gates/use-product-catalog-feature-gate';

import messages from './messages';

import style from './style.module.less';

const ItemBundleSku = ({ bundleProductSku, bundleProductId }) => {
  const dispatch = useDispatch();
  const onBundleClick = useCallback(() => dispatch(openProductDetailModal(bundleProductId)), [dispatch, bundleProductId]);
  const { isFeatureEnabled: isEditProductEnabled, disabledMessage: productLinkDisabledMessage } = useProductCatalogFeatureGate();

  return (
    <div className={style['item-sku']}>
      <FormattedMessage
        {...messages.itemBundleProductSku}
        values={{
          bundleProductSku: (
            <Button
              className={style['item-bundle-sku']}
              disabled={!isEditProductEnabled}
              disabledTooltipMessage={<Text textType={TextType.Paragraph} value={productLinkDisabledMessage} />}
              onClick={onBundleClick}
              theme='link'
            >
              {bundleProductSku}
            </Button>
          ),
        }}
      />
    </div>
  );
};

ItemBundleSku.propTypes = {
  bundleProductSku: PropTypes.string.isRequired,
  bundleProductId: PropTypes.number.isRequired,
};

export { ItemBundleSku };
